import _e from 'common/localeUtil';
import {
	generateButtonClone,
	generateButtonDelete,
	generateButtonDrag
} from './customComponentUtils';

const ServiceItemComponentFactory = editor => {
	editor.DomComponents.addType('service-item', {
		// Make the editor understand when to bind `my-input-type`
		isComponent: el => el && el.tagName === 'DIV' && el.classList.contains('service'),

		// Model definition
		model: {
			// Default properties
			defaults: {
				tagName: 'div',
				highlightable: true,
				attributes: {
					class: 'service column',
					configurable: true
				},
				removable: true,
				badgable: false,
				copyable: false,
				resizable: false,
				selectable: true,
				editable: true,
				draggable: 'div[class*="services-wrapper"]', // Can be dropped only inside `form` elements
				droppable: false, // Can't drop other elements inside
				traits: [],
				components: () => {
					return `<div data-gjs-draggable="true" data-gjs-copyable="false" data-gjs-editable="false" class="service-wrapper"><div class="service-title" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true" >${_e(
						'title'
					)}</div><div class="service-line" ></div><div class="service-description" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true" >${_e(
						'description'
					)}</div></div>`;
				}
			}
		},
		view: {
			// Be default, the tag of the element is the same of the model
			tagName: 'div',

			// Add easily component specific listeners with `events`
			// Being component specific (eg. you can't attach here listeners to window)
			// you don't need to care about removing them when the component is removed,
			// they will be managed automatically by the editor
			events: {
				click: 'clickOnElement',
				// You can also make use of event delegation
				// and listen to events bubbled from some inner element
				'dblclick .inner-el': 'innerElClick'
			},

			innerElClick(ev) {
				ev.stopPropagation();
			},

			// Do something with the content once the element is rendered.
			// The DOM element is passed as `el` in the argument object,
			// but you can access it from any function via `this.el`
			onRender(props) {
				console.log('ServiceItemComponent onRender', props);
				const { el } = props;
				const serviceItemToolbar = document.createElement('div');
				serviceItemToolbar.classList.add('service-item-toolbar');

				// Drag button
				const btnDrag = generateButtonDrag(props, 'services');
				serviceItemToolbar.appendChild(btnDrag);

				// Clone button
				const btnClone = generateButtonClone(props);
				serviceItemToolbar.appendChild(btnClone);

				// Delete button
				const btnDelete = generateButtonDelete(props);
				serviceItemToolbar.appendChild(btnDelete);

				el.append(serviceItemToolbar);
			}
		}
	}); /* API for component type definition */
};
export default ServiceItemComponentFactory;
